import { create } from 'zustand/react';
import { createJSONStorage, persist } from 'zustand/middleware';
import { DateReviver } from '@/store/util';

export type ShiftState = {
  breakStartedAt?: Date;
  status: 'idle' | 'inactive' | 'active';
  lastActiveAt: Date;
  hasBreached: boolean;
};

export const getDefaultState = (): ShiftState => ({
  // Need to specify undefineds explicity
  breakStartedAt: undefined,
  status: 'active',
  lastActiveAt: new Date(),
  hasBreached: false,
});

export const useShiftStore = create(
  persist(getDefaultState, {
    name: 'shift-store',
    storage: createJSONStorage(() => sessionStorage, {
      ...DateReviver<ShiftState>(['breakStartedAt', 'lastActiveAt']),
    }),
  })
);
